const NDFL3_NOTIFICATION_ID = '1151020';
/**
 *  статусы отправки для 3ндфл деклараций
 */
const CARD_STATUS = {
  DRAFT: 0, // Черновик
  SENT: 1, // Отправлено
  RECEIVED: 2, // Получено
  ERROR: 3, // Ошибка
  REGISTERED: 4, // Зарегистрировано
  REJECTED: 5, // Отклонено
  ANSWER_IS_GET: 6, // Получен ответ
  ASSIGNED_TO_SP: 7, // Назначено на СП
  ON_EXECUTION: 8, // На исполнении
  EXECUTED: 9, // Исполнено
  CREATED: 10, // Создано
  INJECTED: 11, // Введено
  ON_CLARIFICATION: 12, // Уточнение
  SENT_ERROR: 13, // Ошибка отправки
  SENT_AWAIT: 14, // Ожидает отправки
};

export { NDFL3_NOTIFICATION_ID, CARD_STATUS };
